import styled from 'styled-components'

import { Section } from 'components/general-styles/General'
import { theme } from 'styles/theme'

const { borderWidths, colors, media, radii, space } = theme

export const Solutions = styled(Section)`
  background-color: ${colors['neutral-background-default']};

  > div {
    gap: ${space['spacing-md']};
  }
`

export const TextWrapper = styled.div`
  h2 {
    margin-top: ${space['spacing-sm']};
    margin-bottom: ${space['spacing-md']};
  }
`

export const SolutionsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${space['spacing-md']};
  
  @media (${media.tablet}) {
    width: 60%;
    margin: auto;
  }
`

export const Option = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 8rem;
  padding: ${space['spacing-sm']};
  gap: ${space['spacing-md']};
  border: ${borderWidths['border-stroke-micro']} solid ${colors['neutral-border-default']};
  border-radius: ${radii['corner-radius-sm']};

  @media (${media.tablet}) {
    min-height: 10rem;
    padding: ${space['spacing-md']};
  }
`

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3.25rem;
  height: 3.25rem;
  background-color: ${colors['neutral-background-hover']};
  border-radius: ${radii['corner-radius-circular']};
`
